
import { Box, Typography, Stack, Pagination, PaginationItem, Grid, Dialog } from '@mui/material';
import { useState, useContext, useEffect, useRef } from "react";
import React from "react";
import {
    ListContainer,
    FourContainer,
    Heading,
    GreenButton,
    RedButton,
} from "../../assets/style"
import { useLazyGetRobotQuery, usePutRobotMutation } from '../../features/NG/NGApiSlice';
import ReactLoading from 'react-loading';
import CountdownContainer from '../CountdownTimer/CountdownContainer';
import { dateTimeToTimeStr2, generateACurrentDateTimeInUTF8 } from '../../utils/dateTimeFormmater';
import { useLazyCheckUserPermissionQuery } from '../../features/remainingWork/remainingWorkApiSlice';

const OverlayConfirmationBox = function ({ open, onClose }: { open: boolean, onClose: (isConfirmedSaving: boolean) => void }) {
    return (
        <Dialog
            open={open}
            onClose={async () => {
                const isConfirmedSaving = false
                onClose(isConfirmedSaving);
            }}
            fullWidth={true}
            PaperProps={{
                style: { borderRadius: "30px" },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "18px",
                }}
            >
                <Box
                    sx={{
                        padding: "15px",
                        backgroundColor: "white",
                        borderRadius: "30px",
                        textAlign: "center",
                        fontSize: "calc(12px + 0.4vw)"
                    }}
                >
                    <span>Are you confirm this error?</span>
                    <div style={{ marginTop: '20px' }}>
                        <GreenButton
                            variant="contained"
                            onClick={async () => {
                                const isConfirmedSaving = true
                                onClose(isConfirmedSaving)
                            }}
                        >
                            Save
                        </GreenButton>
                        <RedButton
                            style={{
                                marginLeft: '20px'
                            }}
                            variant="contained"
                            onClick={async () => {
                                const isConfirmedSaving = false
                                onClose(isConfirmedSaving);
                            }}
                        >
                            Cancel
                        </RedButton>
                    </div>
                </Box>
            </Box>
        </Dialog>
    )
}

function createNGData(
    id: any,
    rfid: any,
    robotCode: number | null,
    error: string,
    time: string,
    acknowledge: any,
) {
    return { id, rfid, robotCode, error, time, acknowledge };
}

const DataTable = ({ NGrows }: { NGrows: any[] }) => {
    const rowsPerPage = 4; // Number of rows per page
    const [currentPage, setCurrentPage] = useState(1);

    const handleChangePage = (event: any, page: number) => {
        setCurrentPage(page);
    };

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const displayedData = NGrows.slice(startIndex, endIndex);

    return (
        <Grid container spacing={0} style={{ backgroundColor: "#FEFFDD", border: "1px solid #95D330", borderRadius: '20px' }}>
            {/* Column Headers */}
            <Grid container style={{ height: 35 }}>
                <Grid xs={1} sm={1} style={{ padding: 10 }}>
                    <Typography variant="subtitle1">&nbsp;&nbsp;No.</Typography>
                </Grid>
                <Grid xs={3} sm={3} style={{ padding: 10 }}>
                    <Typography variant="subtitle1">SN</Typography>
                </Grid>
                <Grid xs={3} sm={3} style={{ padding: 10 }}>
                    <Typography variant="subtitle1">Error</Typography>
                </Grid>
                <Grid xs={2} sm={2} style={{ padding: 10 }}>
                    <Typography variant="subtitle1">Time</Typography>
                </Grid>
                <Grid xs={3} sm={3} style={{ padding: 10 }}>
                    <Typography variant="subtitle1">Action</Typography>
                </Grid>
            </Grid>

            {/* Line Separator */}
            <Grid item xs={12} height='25px'>
                <hr style={{ borderTop: '1px solid #95D330' }} />
            </Grid>

            {/* Data Rows */}
            {displayedData.map((row) => (
                <React.Fragment key={row.id}>
                    <Grid container>
                        <Grid container marginBottom={2} style={{ marginLeft: 10, marginRight: 10, placeItems: 'center', height: 45, backgroundColor: "#FFEEC2", borderRadius: 25 }}>
                            <Grid xs={1} sm={1}>
                                <Typography variant="body1">&nbsp;&nbsp;{row.robotCode ? `${row.robotCode}` : '--'}</Typography>
                            </Grid>
                            <Grid xs={3} sm={3}>
                                <Typography variant="body1">{row.rfid ? `${row.rfid}` : '--'}</Typography>
                            </Grid>
                            <Grid xs={3} sm={3} >
                                <Typography variant="body1">&nbsp;{row.error ? `${row.error}` : '--'}</Typography>
                            </Grid>
                            <Grid xs={2} sm={2}>
                                <Typography variant="body1">&nbsp;&nbsp;&nbsp;{row.time ? `${row.time}` : '--'}</Typography>
                            </Grid>
                            <Grid xs={3} sm={3}>
                                <Typography variant="body2">&nbsp;&nbsp;&nbsp;{row.acknowledge}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </React.Fragment>
            ))}

            {/* Pagination */}
            <Grid marginRight={1} container justifyContent="right" height={40}>
                <Stack direction="row" spacing={2}>
                    {NGrows.length != 0 &&
                        <Box>
                            {startIndex + 1} -{" "}
                            {endIndex > NGrows.length ?
                                (NGrows.length + " of ")
                                : (endIndex + " of ")}
                            {NGrows.length}
                        </Box>
                    }
                    <Pagination
                        count={Math.ceil(NGrows.length / rowsPerPage)}
                        page={currentPage}
                        onChange={handleChangePage}
                        variant="outlined"
                        shape="rounded"
                        sx={{
                            button: { borderColor: "#95D330" },
                        }}
                        renderItem={(item) => (
                            <PaginationItem
                                // components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                {...item}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "#95D330",
                                        color: "white",
                                        borderColor: "transparent",
                                        fontSize: 16,
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "8px"
                                    }
                                }}
                            />
                        )}
                    />
                </Stack>
            </Grid>
        </Grid>
    );
};

const NGContainer = ({ date, userSurName, userOtherName, staffId }: { date: any, userSurName: any, userOtherName: any, staffId: any }) => {
    const [getRobot, { data: robotData, error, isSuccess, isFetching }] = useLazyGetRobotQuery();
    const [putRobot] = usePutRobotMutation();
    const [counter, setCounter] = useState(0)
    const [NGrows, setNGrows] = useState<any[]>([])
    const [startCountdown, setStartCountdown] = useState(true)
    const [secondsLeftOfCountdown, setSecondsLeftOfCountdown] = useState(60)
    const [start, setStart] = useState(false)
    const [openOverlay, setOpenOverlay] = useState(false)
    const [isConfirmedSaving, setIsConfirmedSaving] = useState(false)
    const [selectedRobotError, setSelectedRobotError] = useState<RobotType | null>(null)
    const [checkUserPermissionQuery, checkResult] = useLazyCheckUserPermissionQuery();

    type RobotType = {
        "id": number,
        "robotCode": number | null,
        "errorMessage": string | null,
        "errorTime": string | null,
        "errorCode": string | null,
        "action": string | null,
        "actionTime": string | null,
        "remark": string | null,
        "staffId": string | null,
        "rfid": string | null,
    }

    async function handleConfirmSaving() {
        try {
            await putRobot({
                ...selectedRobotError,
                "action": "ACKNOWLEDGED",
                "actionTime": generateACurrentDateTimeInUTF8().toISOString(),
                "staffId": `${staffId}`
                // "action": "NOT ACKNOWLEDGED",
                // "actionTime": null,
            }).unwrap()
        } catch (error) {
            alert('Please contact your system administrator.-Acknowledge robot error')
        } finally {
            setCounter(counter + 1)
            setOpenOverlay(false)
            setIsConfirmedSaving(false) // reset the state
        }
    }

    function handleCloseOverlay(isConfirmedSaving: boolean) {
        if (isConfirmedSaving) {
            setIsConfirmedSaving(isConfirmedSaving)
        } else if (isConfirmedSaving == false) {
            setOpenOverlay(false)
        }
    }

    function handleOpenOverlay() {
        setOpenOverlay(true)
    }

    // function handleAcknowledgeRobotBefore() {
    //     if (staffId == '03274' // programmer
    //         || staffId == '03354' // programmer
    //         || staffId == '00053'
    //         || staffId == '00134'
    //         || staffId == '00403'
    //         || staffId == '01503'
    //         || staffId == '00089'
    //         || staffId == '00935'
    //         || staffId == '00027'
    //         || staffId == '00469'
    //     ) {
    //         return true
    //     } else
    //         return false
    // }

    const handleAcknowledgeRobot = function (item: RobotType) {
        // if (handleAcknowledgeRobotBefore() == false) {
        //     alert('You don\'t have permission to edit record.');
        //     return
        // }
        checkUserPermissionQuery(staffId).then(async res => {
            if (!res.data) {
                alert('You don\'t have permission to acknowledge NG record.');
                return
            }
            else {
                setSelectedRobotError(item) // prepare POST request's payload, which provides a selection on robot errors
                handleOpenOverlay() // open Confirmation Box
            }
        })
    }

    useEffect(() => {
        if (isConfirmedSaving) {
            // For false => true: save changes to the database
            handleConfirmSaving()
        } else {
            // For true => false: do nothing
        }
    }, [isConfirmedSaving])

    useEffect(() => {
        getRobot(date?.toISOString())
    }, [date?.toISOString(), counter])

    useEffect(() => {
        if (start) {
            const secondsOfCountdown = 60;

            if (secondsLeftOfCountdown === 0) {
                getRobot(date?.toISOString());
                setSecondsLeftOfCountdown(secondsOfCountdown);
            }

            setStartCountdown(true);

            const timeoutID = setTimeout(() => {
                if (secondsLeftOfCountdown > 0) {
                    setSecondsLeftOfCountdown(secondsLeftOfCountdown - 1);
                }
            }, 1000);

            return () => {
                clearTimeout(timeoutID);
            };
        }
    }, [robotData, startCountdown, start, secondsLeftOfCountdown])

    useEffect(() => {
        if (isSuccess) {
            const ngrows = robotData?.map((item: RobotType, index) => {
                const errorDateTime = item.errorTime ? new Date(item.errorTime) : null
                const errorTimeStr = errorDateTime ? dateTimeToTimeStr2(errorDateTime) : ""
                return createNGData(index, item.rfid, item.robotCode, item.errorMessage + "", errorTimeStr, <GreenButton variant="contained" onClick={async () => { await handleAcknowledgeRobot(item) }}>Acknowledge</GreenButton>)
            }) ?? []
            setNGrows(ngrows)
            setStartCountdown(false) // close the zero-second timer
            setStart(true)
        }
    }, [robotData])
    return (
        <>

            < FourContainer flexGrow={1}>
                <Heading>(NG) 待處理問題</Heading>
                {/* <span onClick={handleAcknowledgeRobot}>testPutAPI</span> */}
                <ListContainer className="data-table-2-overide-styles">
                    {
                        isFetching
                            ? <ReactLoading className="justify-items-center" type={"bubbles"} color={'#95D330'} height={'20%'} width={'20%'} />
                            : (
                                < Box sx={{ flexGrow: 1 }}>
                                    <DataTable NGrows={NGrows} />
                                </Box>
                            )
                    }
                </ListContainer>
                <CountdownContainer startCountdown={startCountdown} secondsLeftOfCountdown={secondsLeftOfCountdown} />
            </FourContainer >
            <OverlayConfirmationBox open={openOverlay} onClose={handleCloseOverlay} />
        </>
    )
}
export default NGContainer;